import { produce } from "immer";
import * as Actions from "pages/Mail/ReadMessage/store/messageCalendarActions";

const initialState = {
  isLoading: false
};

const messageCalenderReducer = produce((draft, action) => {
  switch (action.type) {
    case Actions.REPLY_CALENDAR_INVITATION_LOADING: {
      draft.isLoading = true;
      break;
    }
    case Actions.REPLY_CALENDAR_INVITATION_SUCCESS: {
      draft.isLoading = false;
      break;
    }
    case Actions.REPLY_CALENDAR_INVITATION_FAILURE: {
      draft.isLoading = false;
      break;
    }
    default:
      return draft;
  }
}, initialState);

export default messageCalenderReducer;
